import { render, staticRenderFns } from "./LayoutGroupItem.vue?vue&type=template&id=aa98f7e0&scoped=true"
import script from "./LayoutGroupItem.vue?vue&type=script&lang=js"
export * from "./LayoutGroupItem.vue?vue&type=script&lang=js"
import style0 from "./LayoutGroupItem.vue?vue&type=style&index=0&id=aa98f7e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa98f7e0",
  null
  
)

export default component.exports